const VBS_BASE_URL = "https://vbs.jeugdbrandweer.nl";

/** Production and acceptance share the one VBS instance, so there is no per-environment base to configure here. */
export function vbsContactUrl(vbsContactId: number | string): string {
  return `${VBS_BASE_URL}/Contacts/Edit/${vbsContactId}`;
}
